import React, { useState, useEffect } from 'react';

const AppOnboarding = () => {
    const [showModal, setShowModal] = useState(false);
    
    useEffect(() => {
        // 1. Check if running inside our Flutter App (BillifyApp)
        const isApp = navigator.userAgent.includes('BillifyApp');
        
        // 2. Check if user already dismissed
        const hasSeenOnboarding = localStorage.getItem('billify_onboarding_seen');
        
        // 3. Verify if mobile device (simple check)
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        
        if (!isApp && isMobile && !hasSeenOnboarding) {
            // Delay slightly for smoother entrance
            setTimeout(() => setShowModal(true), 1500);
        }
    }, []);

    const handleDismiss = () => {
        setShowModal(false);
        localStorage.setItem('billify_onboarding_seen', 'true');
    };

    if (!showModal) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content overflow-hidden bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-0 max-w-sm w-full mx-4 relative transform transition-all duration-300 scale-100">
                
                {/* Close Button */}
                <button 
                    onClick={handleDismiss}
                    className="absolute top-3 right-3 z-10 p-2 bg-black/5 hover:bg-black/10 rounded-full transition-colors"
                >
                    <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Content */}
                <div className="p-6 text-center">
                    {/* App Logo */}
                    <div className="flex justify-center mb-6">
                        <div className="w-20 h-20 rounded-2xl shadow-lg bg-white flex items-center justify-center">
                            <img src="/logo.png" alt="Billify Logo" className="w-16 h-16 object-contain" />
                        </div>
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Get the Full Experience</h2>
                    <p className="text-gray-500 mb-6 leading-relaxed">
                        Download the official **Billify App** for faster performance, offline access, and smoother animations.
                    </p>

                    {/* Showcase Preview */}
                    <div className="relative w-full h-48 mb-6 rounded-xl overflow-hidden shadow-inner border border-gray-100 bg-gray-50 group">
                         {/* Carousel effect (CSS animation) */}
                        <div className="flex w-[200%] h-full animate-[slideShow_10s_infinite_alternate]">
                            <img src="/showcase1.png" alt="Dashboard" className="w-1/2 h-full object-cover" />
                            <img src="/showcase2.png" alt="Scanning" className="w-1/2 h-full object-cover" />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-white/80 to-transparent pointer-events-none" />
                    </div>

                    {/* Actions */}
                    <div className="space-y-3">
                        <a 
                            href="https://github.com/SUBHOJITPAUL797/kanban-inventory-manager-supabase/releases/tag/v1.0.0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-smooth w-full py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-xl shadow-lg hover:shadow-blue-500/30 flex items-center justify-center gap-2"
                        >
                            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M3.5,14 L3.5,17.5 C3.5,19.4329966 5.06700338,21 7,21 L17,21 C18.9329966,21 20.5,19.4329966 20.5,17.5 L20.5,14 M12,3.5 L12,16 M6,10 L12,16 L18,10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                            </svg>
                            Download for Android
                        </a>
                        
                        <button 
                            onClick={handleDismiss}
                            className="w-full py-3 text-gray-500 font-medium hover:text-gray-800 transition-colors text-sm"
                        >
                            Continue in Browser
                        </button>
                    </div>
                </div>
            </div>

            {/* Inline Styles for Animation */}
            <style jsx="true">{`
                @keyframes slideShow {
                    0%, 45% { transform: translateX(0); }
                    55%, 100% { transform: translateX(-50%); }
                }
            `}</style>
        </div>
    );
};

export default AppOnboarding;
